import React from 'react';
import { Radar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

export default function SpiderChart({ snapshotResult = [], starterLabel = [], leadershipResult = [], leadershipLabel = [] }) {
  const axisLabels = [
    'STRENGTH PERFORMANCE',
    'HEART COLLABORATIVE',
    'SOUL VISIONARY',
    'MIND STRATEGIC'
  ];

  const normalize = str => str.toLowerCase().replace(/\s/g, '');


  const axisMap = axisLabels.map(l => normalize(l.split(' ')[0]));

  const labelAliases = {
    performance: 'Performance',
    performative: 'Performance',
    collaborative: 'collaborative',
    strategic: 'strategic',
    visionary: 'visionary'
  };
  
  const mapDataToAxis = (resultArr, labelArr, axisPart = 0) => {
    return axisLabels.map(axisLabel => {
      let axisKey = normalize(axisLabel.split(' ')[axisPart]);
      axisKey = labelAliases[axisKey] || axisKey;
  
      const idx = labelArr.findIndex(l => {
        let normLabel = normalize(l);
        normLabel = labelAliases[normLabel] || normLabel;
        return normLabel === axisKey;
      });
  
      if (idx !== -1) {
        return resultArr[idx];
      }
      // console.log(`No match for ${axisKey} in`, labelArr);
      return 0;
    });
  };  
  
  

  // const starterData = [0,...mapDataToAxis(snapshotResult, starterLabel, 0)];
  // const leadershipData = [0,...mapDataToAxis(leadershipResult, leadershipLabel, 1)];

  const starterData = mapDataToAxis(snapshotResult, starterLabel, 0);
  const leadershipData = mapDataToAxis(leadershipResult, leadershipLabel, 1);

  const getPointColors = (dataArr, color, threshold = 3) =>
    dataArr.map(val => (parseFloat(val) <= threshold ? 'rgba(0,0,0,0)' : color));
  const getPointRadius = (dataArr, radius, threshold = 3) =>
    dataArr.map(val => (parseFloat(val) <= threshold ? 0 : radius));

  const data = {
    labels: axisLabels,
    datasets: [
      {
        label: 'LIFE',
        data: starterData,
        backgroundColor: '#2457754D',
        borderColor: '#245775',
        pointBackgroundColor: '#245775',
        pointBorderColor: '#245775',
        pointRadius: 0,
        pointHoverRadius: 0,
        pointBorderWidth: 0,
        borderWidth: 2,
        fill: true,
      },
      {
        label: 'LEADERSHIP',
        data: leadershipData,
        backgroundColor: '#BF95404D',
        borderColor: '#C99314',
        pointBackgroundColor: '#C99314',
        pointBorderColor: '#C99314',
        pointRadius: 0,
        pointHoverRadius: 0,
        pointBorderWidth: 0,
        borderWidth: 2,
        fill: true,
      },
    ],
  };

  const horizontalLabelPlugin = {
    id: 'horizontalLabels',
    afterDraw(chart) {
      const ctx = chart.ctx;
      const scale = chart.scales.r;
      
      if (!scale) return;
      
      scale._pointLabelItems.forEach((pointLabel, index) => {
        const label = axisLabels[index];
        if (!label) return;
        
        const parts = label.split(' ');
        
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
     
        const angle = (Math.PI * 2 * index) / axisLabels.length - Math.PI / 2;
        
        const baseRadius = scale.drawingArea;
        let labelDistance = baseRadius + 32; 
        if (Math.abs(Math.cos(angle)) > 0.9) {
          labelDistance = baseRadius + 60; 
        }
        
        const x = centerX + Math.cos(angle) * labelDistance;
        const y = centerY + Math.sin(angle) * labelDistance;
        
        ctx.save();
        ctx.translate(x, y);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.font = 'bold 10px Helvetica';
        
        ctx.fillStyle = '#245775';
        ctx.fillText(parts[0], 0, -10);
        
        if (parts[1]) {
          ctx.fillStyle = '#BF9540';
          ctx.fillText(parts[1], 0, 10);
        }
        
        ctx.restore();
      });
    }
  };

  const options = {
    responsive: true,
    layout: {
      padding: 40,
    },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          font: { size: 10, family: 'Helvetica', weight: '400' },
          color: '#245775',
          boxWidth: 12,
          boxHeight: 12,
          generateLabels: (chart) => [
            {
              text: 'LIFE',
              fillStyle: '#245775', 
              strokeStyle: '#245775',
              lineWidth: 1,
              hidden: false,
              index: 0
            },
            {
              text: 'LEADERSHIP',
              fillStyle: '#C99314', 
              strokeStyle: '#C99314',
              lineWidth: 1,
              hidden: false,
              index: 1
            }
          ]
        },
      },
      tooltip: {
        enabled: false,
      },
    },
    scales: {
      r: {
        min: 0,
        max: 75,
        ticks: {
          display: false,
          stepSize: 15,
        },
        pointLabels: {
          font: { size: 10, family: 'Helvetica' },
          padding: 48,
          callback: () => '',
        },
        grid: {
          color: '#e0e0e0',
          lineWidth: 1,
        },
        angleLines: {
          color: '#e0e0e0',
          lineWidth: 1,
        },
      },
    },
  };

  console.log("data,options",data,options)
  console.log("snapshotResult,leadershipResult",snapshotResult,leadershipResult)
  console.log("starterLabel,leadershipLabel",starterLabel,leadershipLabel)
  

  return (
    <div style={{ width: 400, height: 380, margin: '0 auto' }}>
      <Radar 
        data={data} 
        options={options} 
        plugins={[horizontalLabelPlugin]}
      />
    </div>
  );
}